export const DATASET_PERMISSIONS = {
  DATASET_READ: 'dataset:read',
  DATASET_UPLOAD: 'dataset:upload',
  DATASET_DOWNLOAD: 'dataset:download',
} as const;
